import fetchServer from "../../fetchServer"

export default async function getAirlineCommissions(params) {
  let result = {return: 0,msg: 'Something went wrong fetching airline commissions!'}

  await fetchServer({method: 'GET',url: `/product/v1/airlineCommission/${params?'?'+params:''}`})
  .then((res) => {
    if(res?.data && !res?.data?.error) {
      result = {return: 1,msg: 'Successfull',data: res?.data}
    } else if(res?.data?.error) result['msg'] = res.data.error
  })
  .catch((err) => {
    console.log('Network Error!')
  })

  return result;
}